// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.usermanagementapplicationpermission.RentalManagerUserManagementApplicationPermissionWebApiHandler

import type { QueryOptions, UseMutationOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useMutation, useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerUserManagementApplicationPermissionWebApiHandler_createPermissionRequest,
  RentalManagerUserManagementApplicationPermissionWebApiHandler_createPermissionRequest_Path,
  RentalManagerUserManagementApplicationPermissionWebApiHandler_getApplicationManagerForCompany,
  RentalManagerUserManagementApplicationPermissionWebApiHandler_getApplicationManagerForCompany_Path,
  RentalManagerUserManagementApplicationPermissionWebApiHandler_getUserApplicationPermissionStatuses,
  RentalManagerUserManagementApplicationPermissionWebApiHandler_getUserApplicationPermissionStatuses_Path,
  RentalManagerUserManagementApplicationPermissionWebApiHandler_giveUserApplicationPermission,
  RentalManagerUserManagementApplicationPermissionWebApiHandler_giveUserApplicationPermission_Path,
  RentalManagerUserManagementApplicationPermissionWebApiHandler_removeUserApplicationPermission,
  RentalManagerUserManagementApplicationPermissionWebApiHandler_removeUserApplicationPermission_Path,
  RentalManagerUserManagementApplicationPermissionWebApiHandler_transferApplicationManager,
} from '@zg-rentals/ts-rental-manager-api-client';

import type {
  RentalManagerApplicationManagerWebDto,
  RentalManagerNameDto,
  RentalManagerTransferApplicationManagerRequestDto,
  RentalManagerUserManagementApplicationPermissionUserStatusResponseDto,
} from '@zg-rentals/ts-rental-manager-api-client';

interface CreatePermissionRequestParams {
  userManagementCompanyId: string;
}
interface GiveUserApplicationPermissionParams {
  userManagementCompanyId: string;
  userToken: string;
}
interface RemoveUserApplicationPermissionParams {
  userManagementCompanyId: string;
  userToken: string;
}

export type RentalManagerUserManagementApplicationPermissionWebApiHandler_createPermissionRequest_Options =
  UseQueryOptions<
    RentalManagerNameDto,
    unknown,
    RentalManagerNameDto,
    readonly [string, CreatePermissionRequestParams]
  >;

const RentalManagerUserManagementApplicationPermissionWebApiHandler_createPermissionRequest_GetKey = (
  getParams: CreatePermissionRequestParams,
) => [RentalManagerUserManagementApplicationPermissionWebApiHandler_createPermissionRequest_Path, getParams] as const;

export const RentalManagerUserManagementApplicationPermissionWebApiHandler_createPermissionRequest_queryOptions = (
  getParams: CreatePermissionRequestParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserManagementApplicationPermissionWebApiHandler_createPermissionRequest_GetKey(getParams),
    queryFn: () =>
      RentalManagerUserManagementApplicationPermissionWebApiHandler_createPermissionRequest(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Create a permission request for the logged in user to a company
 */
export const useRentalManagerUserManagementApplicationPermissionWebApiHandler_createPermissionRequest = (
  getParams: CreatePermissionRequestParams,
  {
    httpClient,
    ...options
  }: Omit<
    RentalManagerUserManagementApplicationPermissionWebApiHandler_createPermissionRequest_Options,
    'queryFn' | 'queryKey'
  > & { httpClient?: Client } = {},
) => {
  return useQuery({
    ...RentalManagerUserManagementApplicationPermissionWebApiHandler_createPermissionRequest_queryOptions(getParams, {
      httpClient,
    }),
    ...options,
  });
};
useRentalManagerUserManagementApplicationPermissionWebApiHandler_createPermissionRequest.getKey =
  RentalManagerUserManagementApplicationPermissionWebApiHandler_createPermissionRequest_GetKey;

export type RentalManagerUserManagementApplicationPermissionWebApiHandler_getApplicationManagerForCompany_Options =
  UseQueryOptions<
    RentalManagerApplicationManagerWebDto,
    unknown,
    RentalManagerApplicationManagerWebDto,
    readonly [string]
  >;

const RentalManagerUserManagementApplicationPermissionWebApiHandler_getApplicationManagerForCompany_GetKey = () =>
  [RentalManagerUserManagementApplicationPermissionWebApiHandler_getApplicationManagerForCompany_Path] as const;

export const RentalManagerUserManagementApplicationPermissionWebApiHandler_getApplicationManagerForCompany_queryOptions =
  ({ httpClient }: { httpClient?: Client } = {}) =>
    ({
      ...tsClientOptions.queryOptions,
      queryKey: RentalManagerUserManagementApplicationPermissionWebApiHandler_getApplicationManagerForCompany_GetKey(),
      queryFn: () =>
        RentalManagerUserManagementApplicationPermissionWebApiHandler_getApplicationManagerForCompany(httpClient),
    }) as const satisfies QueryOptions;

/**
 * Get the application manager for the current user's UM Company
 */
export const useRentalManagerUserManagementApplicationPermissionWebApiHandler_getApplicationManagerForCompany = ({
  httpClient,
  ...options
}: Omit<
  RentalManagerUserManagementApplicationPermissionWebApiHandler_getApplicationManagerForCompany_Options,
  'queryFn' | 'queryKey'
> & { httpClient?: Client } = {}) => {
  return useQuery({
    ...RentalManagerUserManagementApplicationPermissionWebApiHandler_getApplicationManagerForCompany_queryOptions({
      httpClient,
    }),
    ...options,
  });
};
useRentalManagerUserManagementApplicationPermissionWebApiHandler_getApplicationManagerForCompany.getKey =
  RentalManagerUserManagementApplicationPermissionWebApiHandler_getApplicationManagerForCompany_GetKey;

export type RentalManagerUserManagementApplicationPermissionWebApiHandler_getUserApplicationPermissionStatuses_Options =
  UseQueryOptions<
    Array<RentalManagerUserManagementApplicationPermissionUserStatusResponseDto>,
    unknown,
    Array<RentalManagerUserManagementApplicationPermissionUserStatusResponseDto>,
    readonly [string]
  >;

const RentalManagerUserManagementApplicationPermissionWebApiHandler_getUserApplicationPermissionStatuses_GetKey = () =>
  [RentalManagerUserManagementApplicationPermissionWebApiHandler_getUserApplicationPermissionStatuses_Path] as const;

export const RentalManagerUserManagementApplicationPermissionWebApiHandler_getUserApplicationPermissionStatuses_queryOptions =
  ({ httpClient }: { httpClient?: Client } = {}) =>
    ({
      ...tsClientOptions.queryOptions,
      queryKey:
        RentalManagerUserManagementApplicationPermissionWebApiHandler_getUserApplicationPermissionStatuses_GetKey(),
      queryFn: () =>
        RentalManagerUserManagementApplicationPermissionWebApiHandler_getUserApplicationPermissionStatuses(httpClient),
    }) as const satisfies QueryOptions;

/**
 * Get all users and their permission status for a UM Company
 */
export const useRentalManagerUserManagementApplicationPermissionWebApiHandler_getUserApplicationPermissionStatuses = ({
  httpClient,
  ...options
}: Omit<
  RentalManagerUserManagementApplicationPermissionWebApiHandler_getUserApplicationPermissionStatuses_Options,
  'queryFn' | 'queryKey'
> & { httpClient?: Client } = {}) => {
  return useQuery({
    ...RentalManagerUserManagementApplicationPermissionWebApiHandler_getUserApplicationPermissionStatuses_queryOptions({
      httpClient,
    }),
    ...options,
  });
};
useRentalManagerUserManagementApplicationPermissionWebApiHandler_getUserApplicationPermissionStatuses.getKey =
  RentalManagerUserManagementApplicationPermissionWebApiHandler_getUserApplicationPermissionStatuses_GetKey;

export type RentalManagerUserManagementApplicationPermissionWebApiHandler_giveUserApplicationPermission_Options =
  UseQueryOptions<void, unknown, void, readonly [string, GiveUserApplicationPermissionParams]>;

const RentalManagerUserManagementApplicationPermissionWebApiHandler_giveUserApplicationPermission_GetKey = (
  getParams: GiveUserApplicationPermissionParams,
) =>
  [
    RentalManagerUserManagementApplicationPermissionWebApiHandler_giveUserApplicationPermission_Path,
    getParams,
  ] as const;

export const RentalManagerUserManagementApplicationPermissionWebApiHandler_giveUserApplicationPermission_queryOptions =
  (getParams: GiveUserApplicationPermissionParams, { httpClient }: { httpClient?: Client } = {}) =>
    ({
      ...tsClientOptions.queryOptions,
      queryKey:
        RentalManagerUserManagementApplicationPermissionWebApiHandler_giveUserApplicationPermission_GetKey(getParams),
      queryFn: () =>
        RentalManagerUserManagementApplicationPermissionWebApiHandler_giveUserApplicationPermission(
          getParams,
          httpClient,
        ),
    }) as const satisfies QueryOptions;

/**
 * Give user application permission
 */
export const useRentalManagerUserManagementApplicationPermissionWebApiHandler_giveUserApplicationPermission = (
  getParams: GiveUserApplicationPermissionParams,
  {
    httpClient,
    ...options
  }: Omit<
    RentalManagerUserManagementApplicationPermissionWebApiHandler_giveUserApplicationPermission_Options,
    'queryFn' | 'queryKey'
  > & { httpClient?: Client } = {},
) => {
  return useQuery({
    ...RentalManagerUserManagementApplicationPermissionWebApiHandler_giveUserApplicationPermission_queryOptions(
      getParams,
      { httpClient },
    ),
    ...options,
  });
};
useRentalManagerUserManagementApplicationPermissionWebApiHandler_giveUserApplicationPermission.getKey =
  RentalManagerUserManagementApplicationPermissionWebApiHandler_giveUserApplicationPermission_GetKey;

export type RentalManagerUserManagementApplicationPermissionWebApiHandler_removeUserApplicationPermission_Options =
  UseQueryOptions<void, unknown, void, readonly [string, RemoveUserApplicationPermissionParams]>;

const RentalManagerUserManagementApplicationPermissionWebApiHandler_removeUserApplicationPermission_GetKey = (
  getParams: RemoveUserApplicationPermissionParams,
) =>
  [
    RentalManagerUserManagementApplicationPermissionWebApiHandler_removeUserApplicationPermission_Path,
    getParams,
  ] as const;

export const RentalManagerUserManagementApplicationPermissionWebApiHandler_removeUserApplicationPermission_queryOptions =
  (getParams: RemoveUserApplicationPermissionParams, { httpClient }: { httpClient?: Client } = {}) =>
    ({
      ...tsClientOptions.queryOptions,
      queryKey:
        RentalManagerUserManagementApplicationPermissionWebApiHandler_removeUserApplicationPermission_GetKey(getParams),
      queryFn: () =>
        RentalManagerUserManagementApplicationPermissionWebApiHandler_removeUserApplicationPermission(
          getParams,
          httpClient,
        ),
    }) as const satisfies QueryOptions;

/**
 * Remove user's application permission
 */
export const useRentalManagerUserManagementApplicationPermissionWebApiHandler_removeUserApplicationPermission = (
  getParams: RemoveUserApplicationPermissionParams,
  {
    httpClient,
    ...options
  }: Omit<
    RentalManagerUserManagementApplicationPermissionWebApiHandler_removeUserApplicationPermission_Options,
    'queryFn' | 'queryKey'
  > & { httpClient?: Client } = {},
) => {
  return useQuery({
    ...RentalManagerUserManagementApplicationPermissionWebApiHandler_removeUserApplicationPermission_queryOptions(
      getParams,
      { httpClient },
    ),
    ...options,
  });
};
useRentalManagerUserManagementApplicationPermissionWebApiHandler_removeUserApplicationPermission.getKey =
  RentalManagerUserManagementApplicationPermissionWebApiHandler_removeUserApplicationPermission_GetKey;

export interface RentalManagerUserManagementApplicationPermissionWebApiHandler_transferApplicationManager_Args {
  postData: RentalManagerTransferApplicationManagerRequestDto;
}

export type RentalManagerUserManagementApplicationPermissionWebApiHandler_transferApplicationManager_Options =
  UseMutationOptions<
    void,
    unknown,
    RentalManagerUserManagementApplicationPermissionWebApiHandler_transferApplicationManager_Args
  >;

/**
 * Transfer application manager role to a new admin
 */
export const useRentalManagerUserManagementApplicationPermissionWebApiHandler_transferApplicationManager = ({
  httpClient,
  ...options
}: Omit<
  RentalManagerUserManagementApplicationPermissionWebApiHandler_transferApplicationManager_Options,
  'mutationFn'
> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserManagementApplicationPermissionWebApiHandler_transferApplicationManager_Args) =>
      RentalManagerUserManagementApplicationPermissionWebApiHandler_transferApplicationManager(
        args.postData,
        httpClient,
      ),
  });
};
